const {
  COMPLETION_CARD_OPTION_KEY_NOT_STARTED,
  COMPLETION_CARD_OPTION_KEY_STARTED,
  COMPLETION_CARD_OPTION_KEY_COMPLETE,
} = require("../constants/completion-card-option-keys");

const STATE_NOT_STARTED = "not_started";
const STATE_STARTED = "started";
const STATE_COMPLETE = "complete";

// XXX: ONE definition of the completion state axis. The assign modal renders it
// XXX: as COLUMNS and the options panel renders it as ROWS -- both must agree on
// XXX: which states exist, their order, their labels, and which option key each
// XXX: one writes. Deriving both from here is what stops the modal and the panel
// XXX: drifting into disagreement about what the author just picked.
const COMPLETION_COLUMNS = [
  { key: STATE_NOT_STARTED, label: "Default (not started)", optionKey: COMPLETION_CARD_OPTION_KEY_NOT_STARTED },
  { key: STATE_STARTED, label: "In Progress", optionKey: COMPLETION_CARD_OPTION_KEY_STARTED },
  { key: STATE_COMPLETE, label: "Completed", optionKey: COMPLETION_CARD_OPTION_KEY_COMPLETE },
];

// Two-state mode collapses "in progress" away: a destination using it only
// distinguishes done from not-done.
function completionColumns(twoStateMode = false) {
  return twoStateMode
    ? COMPLETION_COLUMNS.filter(column => column.key !== STATE_STARTED)
    : [...COMPLETION_COLUMNS];
}

function completionColumnFor(stateKey) {
  return COMPLETION_COLUMNS.find(column => column.key === stateKey) ?? null;
}

module.exports = {
  STATE_NOT_STARTED,
  STATE_STARTED,
  STATE_COMPLETE,
  COMPLETION_COLUMNS,
  completionColumns,
  completionColumnFor,
};
